import { BaseService } from './BaseService';
import { Folder } from '../types';

class FolderService extends BaseService {
  constructor() {
    super('/api/folders');
  }

  async getFolders(): Promise<Folder[]> {
    try {
      const items = await this.get<any[]>('/');
      if (!Array.isArray(items)) return [];
      return items.map(item => ({
        id: item.id || item.Id,
        name: item.name || item.Name,
        description: item.description || item.Description,
        documentCount: item.documentCount ?? item.DocumentCount ?? 0,
        createdOn: item.createdOn || item.CreatedOn
      }));
    } catch (error) {
      console.error('FolderService.getFolders error', error);
      return [];
    }
  }

  async createFolder(name: string, description: string = ''): Promise<string | null> {
    try {
      const response = await this.post<{ id: string }>('/', { name, description });
      return response.id;
    } catch (error) {
      console.error('FolderService.createFolder error', error);
      return null;
    }
  }

  async deleteFolder(id: string): Promise<boolean> {
    try {
      await this.delete(`/${id}`);
      return true;
    } catch (error) {
      console.error('FolderService.deleteFolder error', error);
      return false;
    }
  }

  async updateFolder(id: string, name: string, description: string = ''): Promise<boolean> {
    try {
      await this.put(`/${id}`, { name, description });
      return true;
    } catch (error) {
      console.error('FolderService.updateFolder error', error);
      return false;
    }
  }
}

export const folderService = new FolderService();
